import React, {Component} from 'react';
import ReactGA from 'react-ga';


class App extends Component {
    constructor(props) {
        super(props);

        ReactGA.initialize('UA-101739155-1');

        this.props.history.listen((location, action) => {
            this.trackView(location);
        });
        this.trackView(window.location);
    }

    trackView(location) {
        ReactGA.set({page: location.pathname + location.search});
        ReactGA.pageview(location.pathname + location.search);
    }

    render() {
        return (
            <div className="App">
                {this.props.children}
            </div>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/App.js